export default "__VITE_ASSET__076247bf__"